import { useEffect, useState } from "react";
/**
 * Returns `true` only after `delayMs` has elapsed since mount. Used to suppress
 * a loading skeleton during the first few hundred milliseconds so fast networks
 * never flash a loader between navigation and final content.
 */ function useDelayedReveal(delayMs) {
    const [revealed, setRevealed] = useState(false);
    useEffect(()=>{
        const timeout = setTimeout(()=>setRevealed(true), delayMs);
        return ()=>clearTimeout(timeout);
    }, [
        delayMs
    ]);
    return revealed;
}
export { useDelayedReveal };
